import React, { useCallback, useEffect, useState, useContext } from "react";
import { BoxAd } from "@bloomberg/media-ui-ads";
import { useRegUIClient } from "@foundation/reg-ui-client";
import { useFortress } from "@foundation/fortress";
import styles from "./rightRail.module.css";
import { QuoteContext } from "~context/QuoteContext";
import QuoteSearch from "~components/QuoteSearch";
import { getFortressState } from "~utils/getFortressState";
import { CustomizableTicker } from "~components/dynamic";
import { useLocale } from "~hooks/i18n/useLocale";

const TICKER_DATA_DOMAIN =
  process.env.NEXT_PUBLIC_TICKERLIST_URL ||
  "https://www.bloomberg.com/markets2/api/tickerlist/";
const USER_API_DOMAIN =
  process.env.NEXT_PUBLIC_REGISTRATION_URL || "https://login.bloomberg.com";

const TopSection = () => {
  const quoteData = useContext(QuoteContext);
  // TODO Add top right rail content

  if (!quoteData) {
    return null;
  }

  const { searchClientURL, countryCode } = quoteData;

  return (
    <div className={styles.topSection}>
      <QuoteSearch
        searchURL={searchClientURL}
        countryCode={countryCode}
        className={styles.smallDesktop}
      />
    </div>
  );
};

const MidSection = () => {
  const quoteData = useContext(QuoteContext);
  const fortressContext = useFortress();
  const { isAllowed } = getFortressState(fortressContext);

  // TODO: have 500 page if none of quote data is returning;
  if (!quoteData) {
    return null;
  }

  return (
    <div className={styles.midSectionWrapper}>
      <div className={styles.stickyEnabled}>
        {isAllowed && <BoxAd flexSizeAllowed />}
      </div>
    </div>
  );
};

const BottomSection = () => {
  // TODO Add bottom right rail content
  const quoteData = useContext(QuoteContext);
  const { client } = useRegUIClient();
  const [regUIClient, setRegUIClient] = useState(client);
  const { isJapanese } = useLocale();

  useEffect(() => {
    setRegUIClient(client);
  }, [client]);

  const trackingFunction = useCallback(
    (eventAction: string, eventLabel: string) => {
      window?.dataLayer?.push({
        event: "markets-at-a-glance-click",
        eventCategory: "markets-at-a-glance-engagement",
        eventAction,
        eventLabel,
      });
    },
    []
  );

  // TODO: have 500 page if none of quote data is returning;
  if (!quoteData) {
    return null;
  }

  const { searchClientURL, countryCode } = quoteData;

  return (
    <div>
      {regUIClient && !isJapanese && (
        <CustomizableTicker
          userApiURL={`${USER_API_DOMAIN}/user-api/graphql`}
          tickerDataDomain={TICKER_DATA_DOMAIN}
          mediaServicesSearchURL={searchClientURL}
          regUIClient={regUIClient}
          trackingFunction={trackingFunction}
          className={styles.customizableTicker}
          countryCode={countryCode}
        />
      )}
    </div>
  );
};

export const RightRail = () => {
  return (
    <div className={styles.rightRailWrapper}>
      <div className={styles.rightRail}>
        <TopSection />
        <MidSection />
        <BottomSection />
      </div>
    </div>
  );
};
